/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'
import client from '../assets/svg/testimonials/client.svg'


export const testimonialsData = [
    {
        id: 1,
        name: 'Shandea Hardin',
        title: 'Software Engineer',
        text: "Genise was an absolute pleasure — her creativity and attention to detail transformed our vision into a seamless, user-friendly experience. She delivered on time, communicated clearly, and exceeded every expectation.",
        image: client
    },
    {
        id: 2,
        name: 'Monica Bearden',
        title: 'Community Outreach Engagement Specialist',
        text: "Collaborating with Genise was a great experience that allowed us to visually communicate my organization's mission and impact.",
        image: client
    },
    {
        id: 3,
        name: 'Dewan Aiken',
        title: 'SauceGAME - Owner',
        text: "Genise did an outstanding job designing new product labels for SauceGAME.  Her creative vision and attention to detail brought the brand's soul to life with vibrant, eye catching designs. ",
        image: client
    },
    // {
    //     id: 4,
    //     name: 'Justinee Hanson',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: client
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: client
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: client
    // }
]

